import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

import { TextButton } from '@flipster/react/design-system/text-button';
import Formatted from '@flipster/react/design-utils/formatted';
import { TableCell } from '@flipster/ui/Table';
import { getQuoteCurrencyPrecision } from '@flipster/utils/constants/currency';

import { openPositionRowDataBunja } from '../row-bunja';
import { useOpenPositionRowActions } from '../use-open-position-row-actions';

const MarginCell = memo(() => {
  const { marginAtom, marginTypeAtom, isAirdropAtom, instrumentAtom } = useBunja(openPositionRowDataBunja);
  const margin = useAtomValue(marginAtom);
  const marginType = useAtomValue(marginTypeAtom);
  const isAirdrop = useAtomValue(isAirdropAtom);
  const instrument = useAtomValue(instrumentAtom);
  const { openAdjustMarginModal } = useOpenPositionRowActions();

  if (!instrument) return null;

  const { quoteCurrency } = instrument;
  const quoteCurrencyPrecision = getQuoteCurrencyPrecision(quoteCurrency);

  return (
    <TableCell>
      {isAirdrop || marginType === 'Cross' ? (
        <Formatted.Number
          value={margin}
          precision={quoteCurrencyPrecision}
          suffix={quoteCurrency}
          zeroString='-'
          toFixed
          css={{ textStyle: 'Text/S/Regular' }}
        />
      ) : (
        <TextButton
          as='button'
          color='neutral'
          size='small'
          onClick={openAdjustMarginModal}
          label={
            <Formatted.Number
              value={margin}
              precision={quoteCurrencyPrecision}
              suffix={quoteCurrency}
              zeroString='-'
              toFixed
            />
          }
        />
      )}
    </TableCell>
  );
});

export default MarginCell;
